import { UpdateTaskSorting } from './mutationTypes'

const mutations = {
  /**
   * @param {array}
   */
  [UpdateTaskSorting](state, value) {
    state.task = value
  }
}

export default mutations
